import * as styled from "./Login.styled.jsx";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchAuth } from "../../redux/slices/auth.js";
import { useState, useEffect } from "react";
import { logo } from "../../assets/base-64/logo.js";
import Loader from "../../components/Loader/Loader";
import CryptoJS from "crypto-js";

import { Eye, EyeOff } from "lucide-react";

const ENCRYPTION_KEY = "my_super_secret_key";

function Login() {
  const [userType, setUserType] = useState(null);
  const [notAllowed, setNotAllowed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [autofilled, setAutofilled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  let savedEmail = "";
  let savedPassword = "";

  try {
    const encryptedLogin = localStorage.getItem("savedLogin");
    const encryptedPassword = localStorage.getItem("savedPassword");

    if (encryptedLogin && encryptedPassword) {
      savedEmail = CryptoJS.AES.decrypt(encryptedLogin, ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
      savedPassword = CryptoJS.AES.decrypt(encryptedPassword, ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
    }
  } catch (e) {
    console.error("Ошибка расшифровки:", e);
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      email: savedEmail,
      password: savedPassword,
    },
    mode: "onChange",
  });

  useEffect(() => {
    if (savedEmail && savedPassword) {
      setAutofilled(true);
      setValue("email", savedEmail);
      setValue("password", savedPassword);
    }
  }, [setValue, savedEmail, savedPassword]);

  

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const data = await dispatch(fetchAuth(values));
      if (!data?.payload?.token) throw new Error();

      localStorage.setItem("token", data.payload.token);

      const encryptedEmail = CryptoJS.AES.encrypt(values.email, ENCRYPTION_KEY).toString();
      const encryptedPassword = CryptoJS.AES.encrypt(values.password, ENCRYPTION_KEY).toString();

      localStorage.setItem("savedLogin", encryptedEmail);
      localStorage.setItem("savedPassword", encryptedPassword);

      setUserType(data.payload.userType);
      
    } catch (error) {
      setNotAllowed(true);
      
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userType) {
      navigate(`/${userType}/general`);
    }
  }, [navigate, userType]);

  return (
    <styled.Wrapper>
     

      <styled.Logo src={logo} />
      <styled.FormWrapper>
        <styled.Title>Вхід в особистий кабінет</styled.Title>

        <styled.Form onSubmit={handleSubmit(onSubmit)}>
          <styled.InputWrapper>
            <styled.InputName>Логін</styled.InputName>
            <styled.Input
              placeholder="Введіть логін"
              {...register("email", { required: true })}
              onFocus={() => notAllowed && setNotAllowed(false)}
            />
            <styled.ErrorMessage>
              {errors.email && "Будь ласка, введіть логін, який надав менеджер"}
            </styled.ErrorMessage>
          </styled.InputWrapper>

          <styled.InputWrapper>
            <styled.InputName>Пароль</styled.InputName>
            <styled.PasswordWrapper>
              <styled.Input
                type={showPassword ? "text" : "password"}
                placeholder="Введіть пароль"
                {...register("password", { required: true })}
                onFocus={() => notAllowed && setNotAllowed(false)}
              />
              <styled.PasswordToggle onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
              </styled.PasswordToggle>
            </styled.PasswordWrapper>
            <styled.ErrorMessage>
              {errors.password && "Будь ласка, введіть пароль, який надав менеджер"}
            </styled.ErrorMessage>
          </styled.InputWrapper>

          {!loading && notAllowed && (
            <styled.ErrorMessage>
             Невірний логін або пароль. Перевірте, чи немає пробілів або інших символів.
            </styled.ErrorMessage>
          )}

          {/* {autofilled && (
            <styled.InfoMessage>
              Дані підставлені автоматично.{" "}
              <span onClick={clearSavedData} style={{ cursor: "pointer", color: "#007BFF" }}>
                Очистити
              </span>
            </styled.InfoMessage>
          )} */}

          {loading ? (
            <Loader customWidth={150} />
          ) : (
            <styled.Btn type="submit">Увійти</styled.Btn>
          )}
        </styled.Form>
      </styled.FormWrapper>
    </styled.Wrapper>
  );
}

export default Login;
